exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "security-group-pod .rollup-details .disabled {\n  opacity: 0.4;\n}\nsecurity-group-pod .rollup-details .disabled:active,\nsecurity-group-pod .rollup-details .disabled:hover {\n  opacity: 0.7;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib!./node_modules/less-loader/dist/cjs.js!./app/scripts/modules/core/src/securityGroup/securityGroupPod.directive.less
// module id = 3371
// module chunks = 0